var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVNotsucc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "#DCE0E4",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2734 13.4414C6.64371 9.18663 5.80446 6.99093 5.75567 6.85431C5.70687 6.71281 5.65564 6.5835 5.60197 6.4664C5.47998 6.19316 5.3702 6.05653 5.27261 6.05653C5.20918 6.05653 5.13843 6.06385 5.06036 6.07849C4.98229 6.09313 4.91886 6.06629 4.87007 5.99798C4.82127 5.92967 4.79688 5.84428 4.79688 5.74182C4.79688 5.63935 4.84323 5.53444 4.93594 5.4271C5.03352 5.31975 5.15307 5.22705 5.29457 5.14898C5.60197 4.96844 5.84593 4.87817 6.02647 4.87817C6.207 4.87817 6.35094 4.88305 6.45829 4.89281C6.56564 4.90257 6.66566 4.93917 6.75837 5.0026C6.95354 5.12946 7.117 5.4027 7.24874 5.82233L9.39321 12.2191C9.73477 11.5312 9.98849 11.0042 10.1544 10.6382L10.6082 9.56966C11.1547 8.22296 11.4279 7.27637 11.4279 6.72988V6.63474C11.4279 6.39077 11.3718 6.19804 11.2596 6.05653C11.1522 5.91503 10.9595 5.82965 10.6814 5.80037C10.6326 5.7223 10.6082 5.64179 10.6082 5.55884C10.6082 5.47101 10.6545 5.38563 10.7472 5.30268C10.8448 5.21485 10.9668 5.13922 11.1132 5.07579C11.4157 4.94404 11.7451 4.87817 12.1012 4.87817C12.4623 4.87817 12.7404 4.93429 12.9356 5.04651C13.1357 5.15386 13.2357 5.36855 13.2357 5.69058C13.2357 6.37369 12.7722 7.73259 11.8451 9.76727L11.1791 11.1652C10.7204 12.0923 10.374 12.7217 10.1398 13.0535C9.72013 13.6439 9.35174 13.9391 9.03458 13.9391C8.80525 13.9391 8.60032 13.8488 8.41978 13.6683C8.35635 13.6049 8.30756 13.5292 8.2734 13.4414Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVNotsucc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/v_notsucc.31d856c5d9f3ae678f2be31e180542f4.svg";